// Achievement system logic

export const ACHIEVEMENT_DEFINITIONS = [
  {
    id: 'first_steps',
    title: 'Primeros Pasos',
    description: 'Completa los 6 niveles básicos',
    icon: '🎯',
    requirement: 'complete_6_levels',
    unlocks: 'constructor_levels',
    coinReward: 100,
  },
  {
    id: 'constructor_milestone',
    title: 'Constructor Experto',
    description: 'Completaste 12 niveles avanzados',
    icon: '🏗️',
    requirement: 'complete_12_levels',
    unlocks: 'master_levels',
    coinReward: 200,
  },
  {
    id: 'master',
    title: 'Maestro de n8n',
    description: 'Completaste los 19 niveles y dominaste n8n',
    icon: '👑',
    requirement: 'complete_19_levels',
    unlocks: null,
    coinReward: 500,
  },
];

// Level progression system
export const LEVEL_GROUPS = {
  basic: {
    name: 'Básicos',
    range: [1, 6],
    unlockedBy: null,
  },
  constructor: {
    name: 'Constructor',
    range: [7, 12],
    unlockedBy: 'first_steps',
  },
  master: {
    name: 'Maestro',
    range: [13, 19],
    unlockedBy: 'constructor',
  },
};

// Calculate coins earned per level
export const calculateCoinsForLevel = (levelId) => {
  return levelId * 10; // Level 1 = 10 coins, Level 2 = 20 coins, etc.
};

// Check if user has unlocked an achievement
export const checkAchievementUnlock = (completedLevels) => {
  const count = completedLevels.length;

  if (count >= 6 && !completedLevels.includes('first_steps')) {
    return ACHIEVEMENT_DEFINITIONS[0];
  }
  if (count >= 12 && !completedLevels.includes('constructor_milestone')) {
    return ACHIEVEMENT_DEFINITIONS[1];
  }
  if (count >= 19 && !completedLevels.includes('master')) {
    return ACHIEVEMENT_DEFINITIONS[2];
  }

  return null;
};

// Get unlocked level groups
export const getUnlockedLevelGroups = (unlockedAchievements) => {
  const groups = ['basic']; // Always unlocked

  if (unlockedAchievements.includes('first_steps')) {
    groups.push('constructor');
  }
  if (unlockedAchievements.includes('constructor_milestone')) {
    groups.push('master');
  }

  return groups;
};
